import { useState } from "react";
import { Alert, App, Button, Card, Popconfirm } from "antd";
import { useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { ApiError } from "../../api/client";
import { seedReset } from "../../api/admin";

export function DemoTab() {
  const { t } = useTranslation();
  const { message } = App.useApp();
  const qc = useQueryClient();
  const [busy, setBusy] = useState(false);
  const [off, setOff] = useState(false);
  const go = async () => {
    setBusy(true);
    try {
      await seedReset();
      await qc.invalidateQueries();
      void message.success(t("a_seedDone"));
    } catch (e) {
      if (e instanceof ApiError && e.status === 403) setOff(true);
      else void message.error(e instanceof ApiError ? e.message : t("a_loadFail"));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Card title={t("a_demoData")}>
      <p>{t("a_demoHelp")}</p>
      {off && <Alert type="warning" showIcon style={{ marginBottom: 12 }} message={t("a_seedOff")} />}
      <Popconfirm title={t("a_seedConfirm")} okText={t("yes")} cancelText={t("cancel")} onConfirm={go}>
        <Button danger loading={busy}>{t("a_seedReset")}</Button>
      </Popconfirm>
    </Card>
  );
}
